import PropTypes from "prop-types";
import { ColorPicker } from "primereact/colorpicker";
import Label from "./Label";
import { InputText } from "primereact/inputtext";

const CustomColorPicker = ({
  input,
  label,
  required = false,
  readOnly = false,
  disabled = false,
  resetColor = "#3b82f6",
  resetPossible = false,
}) => {
  const { type, ...inputProps } = input || {};

  return (
    <div
      className={`edexlms-field color-picker ${readOnly ? "readonly" : ""} ${
        disabled ? "disabled" : ""
      } `}
    >
      {(label && (
        <Label
          label={label}
          disabled={disabled}
          required={required}
          htmlFor={input.name}
        />
      )) ||
        null}
      <div className="edexlms-color-picker">
        <ColorPicker
          {...input}
          value={input.value || resetColor}
          onChange={(e) => {
            input.onChange(`#${e.value.replace("#", "")}`);
          }}
          format="hex"
          disabled={disabled}
          style={{
            marginRight: "10px",
          }}
        />
        {(resetPossible &&
          !disabled &&
          input.value &&
          input.value !== resetColor && (
            <i
              className="pi pi-refresh"
              style={{
                marginRight: "10px",
                cursor: "pointer",
              }}
              onClick={() => input.onChange(resetColor)}
            />
          )) ||
          null}
        {(!disabled && (
          <InputText
            {...inputProps}
            id={input.name}
            type={"text"}
            disabled={disabled}
            className={`edexlms-field-input w-full`}
          />
        )) ||
          null}
      </div>
    </div>
  );
};

CustomColorPicker.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  resetPossible: PropTypes.bool,
};

export default CustomColorPicker;
